export const UPDATE_CONSTITUENT = "UPDATE_CONSTITUENT"
export const RECEIVE_CURRENT_CONSTITUENT = "RECEIVE_CURRENT_CONSTITUENT"
export const UPDATE_CONSTITUENT_POSITION = "UPDATE_CONSTITUENT_POSITION"
export const CREATE_CONSTITUENT_POSITION = "CREATE_CONSTITUENT_POSITION"
export const DELETE_CONSTITUENT_POSITION = "DELETE_CONSTITUENT_POSITION"
export const UPDATE_CONSTITUENT_DEGREE = "UPDATE_CONSTITUENT_DEGREE"
export const CREATE_CONSTITUENT_DEGREE = "CREATE_CONSTITUENT_DEGREE"
export const DELETE_CONSTITUENT_DEGREE = "DELETE_CONSTITUENT_DEGREE"
export const UPDATE_CONSTITUENT_CHANGES_PENDING = "UPDATE_CONSTITUENT_CHANGES_PENDING"
export const DELETE_CONSTITUENT = "DELETE_CONSTITUENT"
export const DELETE_ALL_CONSTITUENT_EXPERIENCES = "DELETE_ALL_CONSTITUENT_EXPERIENCES"
export const ADD_CONSTITUENT_AFFINITY = "ADD_CONSTITUENT_AFFINITY"
export const DELETE_CONSTITUENT_AFFINITY = "DELETE_CONSTITUENT_AFFINITY"
export const ADD_CONSTITUENT_RELATIONSHIP = "ADD_CONSTITUENT_RELATIONSHIP"
export const DELETE_CONSTITUENT_RELATIONSHIP = "DELETE_CONSTITUENT_RELATIONSHIP"
export const SAVE_CONSTITUENT_AVATAR = "SAVE_CONSTITUENT_AVATAR"
export const DELETE_CONSTITUENT_AVATAR = "DELETE_CONSTITUENT_AVATAR"
export const TOGGLE_ADMIN_USER_EDIT = "TOGGLE_ADMIN_USER_EDIT"
export const FETCH_NOTES = "FETCH_NOTES"
export const ADD_NOTE = "ADD_NOTE"
export const EDIT_NOTE = "EDIT_NOTE"
export const RECEIVE_EDITED_NOTE = "RECEIVE_EDITED_NOTE"
export const DELETE_NOTE = "DELETE_NOTE"
export const RECEIVE_DELETED_NOTE = "RECEIVE_DELETED_NOTE"
export const RECEIVE_NOTES = "RECEIVE_NOTES"
export const RECEIVE_NOTE = "RECEIVE_NOTE"

export const deleteAllConstituentExperiences = (experienceType, constituentId, success, error) => ({
  type: DELETE_ALL_CONSTITUENT_EXPERIENCES,
  experienceType,
  constituentId,
  success,
  error,
})

export const updateConstituentChangesPending = (pending) => ({
  type: UPDATE_CONSTITUENT_CHANGES_PENDING,
  pending,
})

export const updateConstituentPosition = (position, constituentId, success, error) => ({
  type: UPDATE_CONSTITUENT_POSITION,
  position,
  constituentId,
  success,
  error,
})

export const deleteConstituentPosition = (position, constituentId, error) => ({
  type: DELETE_CONSTITUENT_POSITION,
  position,
  constituentId,
  error,
})

export const createConstituentPosition = (position, constituentId, success, error) => ({
  type: CREATE_CONSTITUENT_POSITION,
  position,
  constituentId,
  success,
  error,
})

export const updateConstituentDegree = (degree, constituentId, success, error) => ({
  type: UPDATE_CONSTITUENT_DEGREE,
  degree,
  constituentId,
  success,
  error,
})

export const deleteConstituentDegree = (degree, constituentId, error) => ({
  type: DELETE_CONSTITUENT_DEGREE,
  degree,
  constituentId,
  error,
})

export const createConstituentDegree = (degree, constituentId, success, error) => ({
  type: CREATE_CONSTITUENT_DEGREE,
  degree,
  constituentId,
  success,
  error,
})

export const addConstituentAffinity = (affinity, constituentId, success, error) => ({
  type: ADD_CONSTITUENT_AFFINITY,
  affinity,
  constituentId,
  success,
  error,
})

export const deleteConstituentAffinity = (affinityId, constituentId, error) => ({
  type: DELETE_CONSTITUENT_AFFINITY,
  affinityId,
  constituentId,
  error,
})

export const addConstituentRelationship = (relationship, constituentId, success, error) => ({
  type: ADD_CONSTITUENT_RELATIONSHIP,
  relationship,
  constituentId,
  success,
  error,
})

export const deleteConstituentRelationship = (relationshipId, constituentId, error) => ({
  type: DELETE_CONSTITUENT_RELATIONSHIP,
  relationshipId,
  constituentId,
  error,
})

export const deleteConstituent = (constituentId, success, error) => ({
  type: DELETE_CONSTITUENT,
  constituentId,
  success,
  error,
})

export const saveConstituentAvatar = (img, constituentId, success, error) => ({
  type: SAVE_CONSTITUENT_AVATAR,
  img,
  constituentId,
  success,
  error,
})

export const deleteConstituentAvatar = (constituentId, error) => ({
  type: DELETE_CONSTITUENT_AVATAR,
  constituentId,
  error,
})

export const toggleAdminUserEdit = () => ({
  type: TOGGLE_ADMIN_USER_EDIT,
})

export const updateConstituent = (constituent, success, error) => ({
  type: UPDATE_CONSTITUENT,
  constituent,
  success,
  error,
})

export const receiveCurrentConstituent = (constituent) => ({
  type: RECEIVE_CURRENT_CONSTITUENT,
  constituent,
})

export const fetchNotes = (constituentId) => ({
  type: FETCH_NOTES,
  constituentId,
})

export const receiveNotes = (notes) => ({
  type: RECEIVE_NOTES,
  notes,
})

export const addNote = (note, constituentId) => ({
  type: ADD_NOTE,
  payload: {
    note,
    constituentId,
  },
})

export const editNote = (noteObject, constituentId) => ({
  type: EDIT_NOTE,
  payload: {
    noteObject,
    constituentId,
  },
})

export const receiveNote = (payload) => ({
  type: RECEIVE_NOTE,
  payload,
})

export const receiveEditedNote = (payload) => ({
  type: RECEIVE_EDITED_NOTE,
  payload,
})

export const receiveDeletedNote = (payload) => ({
  type: RECEIVE_DELETED_NOTE,
  payload,
})

export const deleteNote = (constituentId, id) => ({
  type: DELETE_NOTE,
  payload: {
    id,
    constituentId,
  },
})
